module.exports = __webpack_public_path__ + "img/ec57f5c.jpg";